import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { BroadcastType, PublicationType } from 'propTypes/entities';

import Slider from 'components/sliders/BaseSlider';
import PublicationCard from 'components/cards/entities/PublicationCard';

import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

import Container from 'components/Container';
import LiveCard from 'components/cards/entities/LiveCard';
import styles from './styles.module.scss';

const RelatedEntities = ({ entities }) => {
	const { broadcast, publications } = entities;

	const sliderParams = useMemo(
		() => ({
			slidesPerView: 1,
			spaceBetween: 8,
			breakpoints: {
				[SCREEN_BREAKPOINTS.mobileMedium]: {
					slidesPerView: 2
				},
				[SCREEN_BREAKPOINTS.mobileLarge]: {
					spaceBetween: 12,
					slidesPerView: 2
				},
				[SCREEN_BREAKPOINTS.tabletMedium]: {
					spaceBetween: 16,
					slidesPerView: 3
				},
				[SCREEN_BREAKPOINTS.tabletLarge]: {
					spaceBetween: 24,
					slidesPerView: 3
				}
			}
		}),
		[]
	);

	const cardParams = {
		width: 417,
		height: 300,
		priority: true
	};

	return (
		<Container className={styles.RelatedEntities__Container}>
			<Slider
				params={sliderParams}
				slideHeight="fill"
				className={styles.RelatedEntities}
			>
				{!_(broadcast).isEmpty() && (
					<LiveCard
						key={broadcast._id}
						className={styles.RelatedEntities__Card}
						entity={broadcast}
						params={cardParams}
					/>
				)}
				{!_(publications).isEmpty() &&
					publications.map((publication) => (
						<PublicationCard
							className={styles.RelatedEntities__Card}
							key={publication._id}
							entity={publication}
							params={cardParams}
						/>
					))}
			</Slider>
		</Container>
	);
};

RelatedEntities.propTypes = {
	entities: PropTypes.shape({
		broadcast: BroadcastType,
		publications: PropTypes.arrayOf(PublicationType)
	}).isRequired
};

export default RelatedEntities;
